// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 퇴직정산 페이지 스타일 */
.retirement-settlement {
  min-height: calc(100vh - 80px);
  background-color: #f8f9fa;
}

.retirement-layout {
  display: flex;
  min-height: calc(100vh - 80px);
}

.retirement-settlement .company-sidebar {
  width: 350px;
  min-width: 350px;
  background: white;
  border-right: 1px solid #e1e5e9;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  /* 화면 높이에 고정 — 기업/직원 목록이 자체 스크롤을 갖고 본문으로 스크롤이 번지지 않게 */
  position: sticky;
  top: 80px;
  height: calc(100vh - 80px);
  overflow: hidden;
  transition: width 0.25s ease, min-width 0.25s ease;
}

.retirement-settlement .company-sidebar .sidebar-content {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.retirement-settlement .company-sidebar.folded {
  width: 48px;
  min-width: 48px;
}

.retirement-settlement .company-sidebar.folded .sidebar-content {
  display: none;
}

.sidebar-fold-toggle {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.05);
  color: #495057;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease, color 0.2s ease;
  z-index: 2;
}

.sidebar-fold-toggle:hover {
  background: rgba(0, 123, 255, 0.12);
  color: #007bff;
}

.sidebar-fold-icon {
  font-size: 1.1rem;
  font-weight: bold;
  line-height: 1;
}

.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle {
  right: 50%;
  transform: translateX(50%);
  background: #f8f9fa;
  border: 1px solid #e1e5e9;
}

.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle:hover {
  background: #e9ecef;
}

.sidebar-fold-label {
  position: absolute;
  top: 44px;
  left: 50%;
  transform: translateX(-50%);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 0.8rem;
  font-weight: 600;
  color: #495057;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

/* 접기 단추: 펼친 상태는 신규 기업 등록 아래에 사이드바 폭을 가득 채운 넓은 단추, 접은 상태는 세로 띠 전체가 단추 */
.sidebar-fold-toggle {
  position: static;
  flex: none;
  width: auto;
  height: 40px;
  margin: 0 1rem 1rem;
  gap: 6px;
  border: 1px solid #ced4da;
  border-radius: 8px;
  background: #f1f3f5;
  color: #212529;
  font-size: 0.95rem;
  font-weight: 600;
}
.sidebar-fold-toggle::after { content: '기업검색 접기'; }
.sidebar-fold-toggle:hover { border-color: #007bff; }
.sidebar-fold-icon { font-size: 1.5rem; }
.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  transform: none;
  align-items: flex-start;
  padding-top: 10px;
  border: none;
  border-radius: 0;
  background: #f8f9fa;
}
.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle::after { content: none; }
.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle:hover { background: #e7f1ff; }
.sidebar-fold-label { top: 52px; z-index: 3; pointer-events: none; }

.retirement-content {
  flex: 1 1;
  background: white;
  overflow-y: auto;
}

/* 퇴직정산 데이터 표시 영역 */
.retirement-data-display {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
}

.retirement-data-header {
  padding: 1rem;
  background: white;
  border-bottom: 1px solid #e1e5e9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.retirement-data-header h2 {
  margin: 0 0 0.5rem 0;
  color: #333;
  font-size: 1.3rem;
  font-weight: 600;
}

.employee-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.employee-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #495057;
}

.employee-details {
  font-size: 0.9rem;
  color: #6c757d;
}

.retirement-data-content {
  flex: 1 1;
  padding: 1rem;
  overflow: hidden;
}


.employee-list-section {
  flex: 1 1;
  padding: 1rem;
  overflow-y: auto;
}

.employee-list-section h4 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
  border-bottom: 1px solid #e1e5e9;
  padding-bottom: 0.5rem;
}

.employee-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.employee-item {
  padding: 0.75rem;
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.employee-item:hover {
  background: #f8f9fa;
  border-color: #667eea;
}

.employee-item.selected {
  background: #e3f2fd;
  border-color: #2196f3;
  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);
}

.employee-item .employee-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
}

.employee-item .employee-info {
  font-size: 0.8rem;
  color: #666;
}

.retirement-detail {
  text-align: center;
  padding: 2rem;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.retirement-icon {
  margin-bottom: 2rem;
}

.construction-icon {
  font-size: 4rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.retirement-header h1 {
  color: #333;
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  background: linear-gradient(135deg, #667eea, #764ba2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.retirement-subtitle {
  color: #666;
  font-size: 1rem;
  font-weight: 400;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.selected-company-info {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  display: inline-block;
}

.company-label {
  color: #1565c0;
  font-weight: 600;
  margin-right: 0.5rem;
}

.company-name {
  color: #1976d2;
  font-weight: 700;
}

.retirement-message {
  margin-bottom: 2rem;
}

.message-box {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 15px;
  padding: 2rem;
  margin-bottom: 2rem;
  border: 1px solid #dee2e6;
}

.message-box h2 {
  color: #495057;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.message-box p {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
}

.feature-preview {
  background: #fff;
  border-radius: 15px;
  padding: 1.5rem;
  border: 2px solid #e3f2fd;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.1);
}

.feature-preview h3 {
  color: #1976d2;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.feature-preview h3::before {
  content: "✨";
  font-size: 1rem;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}

.feature-list li {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  color: #1565c0;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
}

.feature-list li::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.feature-list li:hover::before {
  left: 100%;
}

.feature-list li:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);
}

.retirement-actions {
  margin-bottom: 2rem;
}

.retirement-actions .btn {
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 25px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.retirement-actions .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

.retirement-footer {
  border-top: 1px solid #e9ecef;
  padding-top: 1.5rem;
}

.retirement-footer p {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0;
  font-style: italic;
}

/* 기업 선택 없을 때 스타일 */
.no-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.no-selection-content {
  text-align: center;
  padding: 3rem;
  max-width: 500px;
}

.no-selection-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  opacity: 0.7;
}

.no-selection h3 {
  color: #495057;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.no-selection p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0 0 2rem 0;
  line-height: 1.5;
}

.no-selection-features {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  font-size: 1.5rem;
}

.feature-item span:last-child {
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;
}

/* 에러 컨테이너 */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  text-align: center;
}

.retry-btn {
  margin-top: 1rem;
  padding: 0.75rem 1.5rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.retry-btn:hover {
  background: #0056b3;
}


/* 직원 선택 콘텐츠 */
.employee-selection-content {
  text-align: center;
  padding: 2rem;
  animation: fadeInUp 0.6s ease-out;
}

/* 반응형 디자인 */
@media (max-width: 1024px) {
  .retirement-settlement .company-sidebar {
    width: 320px;
    min-width: 320px;
  }
  .retirement-settlement .company-sidebar.folded {
    width: 48px;
    min-width: 48px;
  }
}

@media (max-width: 768px) {
  .retirement-layout {
    flex-direction: column;
  }
  
  .retirement-settlement .company-sidebar {
    width: 100%;
    height: 300px;
    border-right: none;
    border-bottom: 1px solid #e1e5e9;
  }
  
  .retirement-content {
    min-height: calc(100vh - 380px);
  }
  
  .no-selection-content {
    padding: 2rem 1rem;
  }
  
  .no-selection-features {
    flex-direction: column;
    gap: 1rem;
  }
  
  .feature-item {
    flex-direction: row;
    justify-content: center;
    padding: 0.75rem 1rem;
  }
  
  .retirement-header h1 {
    font-size: 2rem;
  }
  
  .construction-icon {
    font-size: 3rem;
  }
  
  .message-box {
    padding: 1.5rem;
  }
  
  .feature-preview {
    padding: 1rem;
  }
  
  .feature-list {
    grid-template-columns: 1fr;
  }
  
  .retirement-actions .btn {
    padding: 0.6rem 1.5rem;
    font-size: 0.9rem;
  }
  
  .employee-selection-content {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .retirement-settlement .company-sidebar {
    height: 250px;
  }
  
  .retirement-content {
    min-height: calc(100vh - 330px);
  }
  
  .no-selection-icon {
    font-size: 3rem;
  }
  
  .no-selection h3 {
    font-size: 1.25rem;
  }
  
  .no-selection p {
    font-size: 0.9rem;
  }
  
  .retirement-header h1 {
    font-size: 1.75rem;
  }
  
  .construction-icon {
    font-size: 2.5rem;
  }
  
  .message-box {
    padding: 1rem;
  }
  
  .feature-list li {
    padding: 0.6rem 0.8rem;
    font-size: 0.85rem;
  }
  
  .employee-selection-content {
    padding: 1rem;
  }
}

/* 퇴직정산 담기 슬라이드 창 */
.retirement-cart-slide {
  position: fixed;
  top: 80px;
  right: 0;
  width: 1200px;
  height: calc(100vh - 80px);
  background: white;
  border-left: 1px solid #e1e5e9;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: translateX(0);
  transition: transform 0.3s ease;
}

.cart-header {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e1e5e9;
  background: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.cart-header h3 {
  margin: 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}

.cart-close-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.cart-close-btn:hover {
  background: #c82333;
  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3);
}

.cart-controls {
  display: flex;
  gap: 0.5rem;
}

.cart-download-btn {
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.4rem 0.8rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.cart-download-btn:hover:not(:disabled) {
  background: #218838;
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);
}

.cart-download-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.cart-clear-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.4rem 0.6rem;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cart-clear-btn:hover {
  background: #5a6268;
}

.cart-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.75rem;
}

.cart-empty {
  text-align: center;
  padding: 1.5rem;
  color: #6c757d;
}

.cart-items {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cart-item {
  background: #f8f9fa;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 1rem;
  transition: all 0.2s ease;
}

.cart-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.cart-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.cart-item-header h4 {
  margin: 0;
  color: #495057;
  font-size: 1rem;
  font-weight: 600;
}

.remove-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.remove-btn:hover {
  background: #c82333;
}

.cart-item-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-row .label {
  color: #6c757d;
  font-size: 0.85rem;
  font-weight: 500;
}

.detail-row .value {
  color: #212529;
  font-size: 0.85rem;
  font-weight: 600;
}

.detail-row.total {
  border-top: 1px solid #dee2e6;
  padding-top: 0.5rem;
  margin-top: 0.5rem;
}

.detail-row.total .label {
  color: #495057;
  font-weight: 600;
}

.detail-row.total .value {
  color: #28a745;
  font-weight: 700;
  font-size: 0.9rem;
}

/* 담기 버튼 스타일 */
.cart-actions {
  padding: 1rem;
  border-top: 1px solid #e1e5e9;
  background: #f8f9fa;
}

.add-to-cart-btn {
  width: 100%;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.add-to-cart-btn:hover:not(:disabled) {
  background: #218838;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.add-to-cart-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 카트 아이템 목록 스타일 - 간소화 */
.cart-item-list {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1rem;
}

.cart-item-summary {
  background: #f8f9fa;
  border: 1px solid #e1e5e9;
  border-radius: 4px;
  padding: 0.4rem 0.6rem;
  transition: all 0.2s ease;
}

.cart-item-summary:hover {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.cart-item-simple {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}

.employee-name {
  font-weight: 600;
  color: #495057;
  font-size: 0.85rem;
}

.employee-residentNumber {
  font-weight: 600;
  color: #495057;
  font-size: 0.85rem;
}

.employee-joinDate {
  font-weight: 600;
  color: #495057;
  font-size: 0.85rem;
}

.employee-amount {
  font-weight: 700;
  color: #28a745;
  font-size: 0.85rem;
}

/* 접혀있을 때 펼치기 버튼 */
.cart-expand-button {
  position: fixed;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  z-index: 1001;
}

.cart-expand-btn {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 1rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

.cart-expand-btn:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
}

/* 카트 테이블 스타일 */
.cart-table-container {
  margin-top: 0.75rem;
  border-top: 2px solid #007bff;
  padding-top: 0.75rem;
}

.table-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.year-section {
  margin-bottom: 1.25rem;
}

.year-section:last-child {
  margin-bottom: 0;
}

.year-title {
  margin: 0 0 0.6rem 0;
  color: #495057;
  font-size: 0.95rem;
  font-weight: 700;
  padding: 0.6rem 0.8rem;
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: white;
  border-radius: 4px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 123, 255, 0.2);
}

.matrix-table-wrapper {
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid #e1e5e9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.matrix-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 0.8rem;
  min-width: 400px;
}

.matrix-table thead {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
}

.matrix-table th {
  padding: 0.6rem 0.4rem;
  text-align: center;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  font-size: 0.75rem;
  white-space: nowrap;
}

.matrix-table td {
  padding: 0.5rem 0.4rem;
  text-align: center;
  border-bottom: 1px solid #f1f3f4;
  font-size: 0.75rem;
  white-space: nowrap;
}

.matrix-table tbody tr:hover {
  background: #f8f9fa;
}

.year-month-header {
  background: #007bff !important;
  color: white !important;
  font-weight: 700 !important;
  position: sticky;
  left: 0;
  z-index: 10;
}

.year-month-cell {
  font-weight: 600;
  color: #495057;
  background: #f8f9fa;
  position: sticky;
  left: 0;
  z-index: 5;
  border-right: 2px solid #dee2e6;
}

.employee-header {
  background: #28a745 !important;
  color: white !important;
  font-weight: 700 !important;
  min-width: 120px;
  padding: 0.5rem 0.3rem !important;
}

/* 카트 매트릭스 테이블 헤더(초록 배경) 전용 — 스코프 없이 두면
   직원 검색 목록/데이터 헤더의 같은 클래스에 흰색·민트색이 새어 나감 */
.matrix-table .employee-header .employee-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
}

.matrix-table .employee-header .employee-name {
  font-size: 0.8rem;
  font-weight: 700;
  color: white;
}

.matrix-table .employee-header .employee-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
}

.matrix-table .employee-header .employee-id {
  font-size: 0.65rem;
  color: #e8f5e8;
  font-weight: 500;
}

.matrix-table .employee-header .employee-date {
  font-size: 0.65rem;
  color: #e8f5e8;
  font-weight: 500;
}

.amount-cell {
  font-weight: 500;
  color: #495057;
  min-width: 80px;
}

/* 합계 행 스타일 */
.total-row {
  background: #e3f2fd !important;
  border-top: 2px solid #2196f3 !important;
}

.total-row:hover {
  background: #bbdefb !important;
}

.total-label {
  font-weight: 700 !important;
  color: #1976d2 !important;
  background: #e3f2fd !important;
  position: sticky;
  left: 0;
  z-index: 5;
  border-right: 2px solid #2196f3 !important;
}

.total-amount-cell {
  font-weight: 700 !important;
  color: #1976d2 !important;
  background: #e3f2fd !important;
}

/* 퇴직정산 행 스타일 */
.retirement-row {
  background: #f3e5f5 !important;
  border-top: 2px solid #9c27b0 !important;
}

.retirement-row:hover {
  background: #e1bee7 !important;
}

.retirement-label {
  font-weight: 700 !important;
  color: #7b1fa2 !important;
  background: #f3e5f5 !important;
  position: sticky;
  left: 0;
  z-index: 5;
  border-right: 2px solid #9c27b0 !important;
}

.retirement-amount-cell {
  font-weight: 700 !important;
  color: #7b1fa2 !important;
  background: #f3e5f5 !important;
}

/* 총합계 행 스타일 */
.grand-total-row {
  background: #fff3e0 !important;
  border-top: 3px solid #ff9800 !important;
}

.grand-total-row:hover {
  background: #ffe0b2 !important;
}

.grand-total-label {
  font-weight: 800 !important;
  color: #f57c00 !important;
  background: #fff3e0 !important;
  position: sticky;
  left: 0;
  z-index: 5;
  border-right: 2px solid #ff9800 !important;
  font-size: 0.85rem !important;
}

.grand-total-amount {
  font-weight: 800 !important;
  color: #f57c00 !important;
  background: #fff3e0 !important;
  font-size: 0.85rem !important;
  text-align: center !important;
}

/* 퇴직정산 선택 패널 스타일 */
.retirement-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 2rem;
}

.retirement-options {
  margin: 2rem 0;
  width: 100%;
  max-width: 800px;
}

.option-cards {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
}

.option-card {
  background: white;
  border: 2px solid #e1e5e9;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1 1;
  max-width: 400px;
}

.option-card:hover {
  border-color: #007bff;
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 123, 255, 0.2);
}

.option-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.option-card h3 {
  color: #495057;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.option-card p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0 0 1.5rem 0;
}

.option-features ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.option-features li {
  color: #495057;
  font-size: 0.9rem;
  padding: 0.3rem 0;
  position: relative;
  padding-left: 1.5rem;
}

.option-features li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #28a745;
  font-weight: bold;
}

/* 패널 스타일 */
.retirement-panel {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.panel-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e1e5e9;
  background: #f8f9fa;
}

.back-to-selection-btn {
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
  /* Login.css의 전역 button { width: 100% } 누수 방지 — 내용 크기만큼만 */
  width: auto;
  flex: 0 0 auto;
  white-space: nowrap;
}

.back-to-selection-btn:hover {
  background: #5a6268;
}

.panel-header h2 {
  margin: 0;
  color: #495057;
  font-size: 1.5rem;
  font-weight: 600;
}

.panel-content {
  flex: 1 1;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-message {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.panel-message h3 {
  color: #495057;
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
}

.panel-message p {
  color: #6c757d;
  font-size: 1rem;
  margin: 0 0 1rem 0;
}

.selection-guide {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.selection-guide p {
  color: #495057;
  font-size: 0.9rem;
  margin: 0;
  font-style: italic;
}

/* 반응형 디자인 */
@media (max-width: 1400px) {
  .retirement-cart-slide {
    width: 1000px;
  }
}

@media (max-width: 1200px) {
  .retirement-cart-slide {
    width: 800px;
  }
  
  .matrix-table {
    font-size: 0.75rem;
  }
  
  .matrix-table th,
  .matrix-table td {
    padding: 0.4rem 0.3rem;
  }
  
  .employee-header {
    min-width: 100px;
  }
  
  .amount-cell {
    min-width: 70px;
  }
}

@media (max-width: 768px) {
  .retirement-cart-slide {
    width: 100%;
    height: calc(100vh - 80px);
  }
  
  .cart-header {
    padding: 0.75rem;
  }
  
  .cart-content {
    padding: 0.75rem;
  }
  
  .cart-item-summary {
    padding: 0.4rem;
  }
  
  .matrix-table {
    font-size: 0.7rem;
  }
  
  .matrix-table th,
  .matrix-table td {
    padding: 0.3rem 0.2rem;
  }
  
  .year-title {
    font-size: 0.85rem;
    padding: 0.4rem 0.6rem;
  }
  
  .employee-header {
    min-width: 80px;
  }
  
  .amount-cell {
    min-width: 60px;
  }
  
  .matrix-table .employee-header .employee-name {
    font-size: 0.7rem;
  }

  .matrix-table .employee-header .employee-id,
  .matrix-table .employee-header .employee-date {
    font-size: 0.6rem;
  }
  
  /* 선택 패널 반응형 */
  .retirement-selection {
    padding: 1rem;
  }
  
  .option-cards {
    flex-direction: column;
    gap: 1rem;
  }
  
  .option-card {
    padding: 1.5rem;
  }
  
  .option-icon {
    font-size: 2.5rem;
  }
  
  .option-card h3 {
    font-size: 1.3rem;
  }
  
  .panel-header {
    padding: 0.75rem 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .panel-header h2 {
    font-size: 1.3rem;
  }
  
  .panel-content {
    padding: 1rem;
  }
  
  .panel-message {
    padding: 2rem;
  }
}

@media (max-width: 480px) {
  .cart-header h3 {
    font-size: 1rem;
  }
  
  .cart-item-header h4 {
    font-size: 0.9rem;
  }
  
  .detail-row .label,
  .detail-row .value {
    font-size: 0.8rem;
  }
}

/* ── 연도별 부담금 (카트) ── */
.cart-item-yearly {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px 8px 8px;
  font-size: 0.75rem;
}

.cart-yearly-chip {
  background: #ede7f6;
  color: #4527a0;
  border-radius: 8px;
  padding: 1px 8px;
  white-space: nowrap;
}

.cart-leave-warning {
  color: #e65100;
  font-weight: 700;
  margin-left: 4px;
}

.matrix-table .year-contrib-row td {
  background: #ede7f6;
  font-weight: 600;
  color: #4527a0;
}

.matrix-table .year-contrib-row .retirement-label {
  white-space: nowrap;
}

/* 직원을 바꿔 자료를 다시 받는 동안: 화면 전체 대신 표 위에만 반투명 막을 씌운다 */
.retirement-data-content { position: relative; }
.retirement-data-display.is-loading .retirement-data-content > :not(.retirement-loading-veil) { opacity: 0.45; transition: opacity 0.15s; }
.retirement-loading-veil { position: absolute; top: 12px; left: 50%; z-index: 5; transform: translateX(-50%); padding: 4px 12px; border-radius: 12px; background: #1864ab; color: #fff; font-size: 12.5px; font-weight: 600; }
.retirement-inline-loading { padding: 24px; color: #6c757d; text-align: center; }
.retirement-inline-error { margin: 8px 0; padding: 8px 12px; border-radius: 4px; background: #fdf0f1; color: #b02a37; }
`, "",{"version":3,"sources":["webpack://./src/components/RetirementSettlement.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,sDAAsD;EACtD,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA,8BAA8B,kBAAkB,EAAE;AAClD,6BAA6B,qBAAqB,EAAE;AACpD,qBAAqB,iBAAiB,EAAE;AACxC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA,6EAA6E,aAAa,EAAE;AAC5F,4EAA4E,mBAAmB,EAAE;AACjG,sBAAsB,SAAS,EAAE,UAAU,EAAE,oBAAoB,EAAE;;AAEnE;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;;AAGA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,cAAc;AACd;EACE,kBAAkB;EAClB,aAAa;EACb,iCAAiC;AACnC;;AAEA,YAAY;AACZ;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,8BAA8B;EAC9B,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;2CAC2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,0DAA0D;EAC1D,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA,cAAc;EACd;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD,2BAA2B,kBAAkB,EAAE;AAC/C,gGAAgG,aAAa,EAAE,yBAAyB,EAAE;AAC1I,2BAA2B,kBAAkB,EAAE,SAAS,EAAE,SAAS,EAAE,UAAU,EAAE,2BAA2B,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,WAAW,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC7N,6BAA6B,aAAa,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAChF,2BAA2B,aAAa,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE","sourcesContent":["/* 퇴직정산 페이지 스타일 */\r\n.retirement-settlement {\r\n  min-height: calc(100vh - 80px);\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.retirement-layout {\r\n  display: flex;\r\n  min-height: calc(100vh - 80px);\r\n}\r\n\r\n.retirement-settlement .company-sidebar {\r\n  width: 350px;\r\n  min-width: 350px;\r\n  background: white;\r\n  border-right: 1px solid #e1e5e9;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);\r\n  /* 화면 높이에 고정 — 기업/직원 목록이 자체 스크롤을 갖고 본문으로 스크롤이 번지지 않게 */\r\n  position: sticky;\r\n  top: 80px;\r\n  height: calc(100vh - 80px);\r\n  overflow: hidden;\r\n  transition: width 0.25s ease, min-width 0.25s ease;\r\n}\r\n\r\n.retirement-settlement .company-sidebar .sidebar-content {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.retirement-settlement .company-sidebar.folded {\r\n  width: 48px;\r\n  min-width: 48px;\r\n}\r\n\r\n.retirement-settlement .company-sidebar.folded .sidebar-content {\r\n  display: none;\r\n}\r\n\r\n.sidebar-fold-toggle {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  width: 28px;\r\n  height: 28px;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: none;\r\n  border-radius: 6px;\r\n  background: rgba(0, 0, 0, 0.05);\r\n  color: #495057;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s ease, color 0.2s ease;\r\n  z-index: 2;\r\n}\r\n\r\n.sidebar-fold-toggle:hover {\r\n  background: rgba(0, 123, 255, 0.12);\r\n  color: #007bff;\r\n}\r\n\r\n.sidebar-fold-icon {\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  line-height: 1;\r\n}\r\n\r\n.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle {\r\n  right: 50%;\r\n  transform: translateX(50%);\r\n  background: #f8f9fa;\r\n  border: 1px solid #e1e5e9;\r\n}\r\n\r\n.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle:hover {\r\n  background: #e9ecef;\r\n}\r\n\r\n.sidebar-fold-label {\r\n  position: absolute;\r\n  top: 44px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  writing-mode: vertical-rl;\r\n  text-orientation: mixed;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  letter-spacing: 0.05em;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 접기 단추: 펼친 상태는 신규 기업 등록 아래에 사이드바 폭을 가득 채운 넓은 단추, 접은 상태는 세로 띠 전체가 단추 */\r\n.sidebar-fold-toggle {\r\n  position: static;\r\n  flex: none;\r\n  width: auto;\r\n  height: 40px;\r\n  margin: 0 1rem 1rem;\r\n  gap: 6px;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 8px;\r\n  background: #f1f3f5;\r\n  color: #212529;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n}\r\n.sidebar-fold-toggle::after { content: '기업검색 접기'; }\r\n.sidebar-fold-toggle:hover { border-color: #007bff; }\r\n.sidebar-fold-icon { font-size: 1.5rem; }\r\n.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  transform: none;\r\n  align-items: flex-start;\r\n  padding-top: 10px;\r\n  border: none;\r\n  border-radius: 0;\r\n  background: #f8f9fa;\r\n}\r\n.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle::after { content: none; }\r\n.retirement-settlement .company-sidebar.folded .sidebar-fold-toggle:hover { background: #e7f1ff; }\r\n.sidebar-fold-label { top: 52px; z-index: 3; pointer-events: none; }\r\n\r\n.retirement-content {\r\n  flex: 1;\r\n  background: white;\r\n  overflow-y: auto;\r\n}\r\n\r\n/* 퇴직정산 데이터 표시 영역 */\r\n.retirement-data-display {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.retirement-data-header {\r\n  padding: 1rem;\r\n  background: white;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.retirement-data-header h2 {\r\n  margin: 0 0 0.5rem 0;\r\n  color: #333;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.employee-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.employee-name {\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.employee-details {\r\n  font-size: 0.9rem;\r\n  color: #6c757d;\r\n}\r\n\r\n.retirement-data-content {\r\n  flex: 1;\r\n  padding: 1rem;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n.employee-list-section {\r\n  flex: 1;\r\n  padding: 1rem;\r\n  overflow-y: auto;\r\n}\r\n\r\n.employee-list-section h4 {\r\n  margin: 0 0 1rem 0;\r\n  color: #333;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.employee-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.employee-item {\r\n  padding: 0.75rem;\r\n  background: white;\r\n  border: 1px solid #e1e5e9;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.employee-item:hover {\r\n  background: #f8f9fa;\r\n  border-color: #667eea;\r\n}\r\n\r\n.employee-item.selected {\r\n  background: #e3f2fd;\r\n  border-color: #2196f3;\r\n  box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);\r\n}\r\n\r\n.employee-item .employee-name {\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.employee-item .employee-info {\r\n  font-size: 0.8rem;\r\n  color: #666;\r\n}\r\n\r\n.retirement-detail {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  animation: fadeInUp 0.6s ease-out;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.retirement-icon {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.construction-icon {\r\n  font-size: 4rem;\r\n  animation: bounce 2s infinite;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 20%, 50%, 80%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  40% {\r\n    transform: translateY(-10px);\r\n  }\r\n  60% {\r\n    transform: translateY(-5px);\r\n  }\r\n}\r\n\r\n.retirement-header h1 {\r\n  color: #333;\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin: 0 0 0.5rem 0;\r\n  background: linear-gradient(135deg, #667eea, #764ba2);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.retirement-subtitle {\r\n  color: #666;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  margin: 0 0 1rem 0;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.selected-company-info {\r\n  background: linear-gradient(135deg, #e3f2fd, #bbdefb);\r\n  border-radius: 8px;\r\n  padding: 0.75rem 1rem;\r\n  margin-top: 1rem;\r\n  display: inline-block;\r\n}\r\n\r\n.company-label {\r\n  color: #1565c0;\r\n  font-weight: 600;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.company-name {\r\n  color: #1976d2;\r\n  font-weight: 700;\r\n}\r\n\r\n.retirement-message {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.message-box {\r\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\r\n  border-radius: 15px;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.message-box h2 {\r\n  color: #495057;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.message-box p {\r\n  color: #6c757d;\r\n  font-size: 1rem;\r\n  line-height: 1.6;\r\n  margin: 0;\r\n}\r\n\r\n.feature-preview {\r\n  background: #fff;\r\n  border-radius: 15px;\r\n  padding: 1.5rem;\r\n  border: 2px solid #e3f2fd;\r\n  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.1);\r\n}\r\n\r\n.feature-preview h3 {\r\n  color: #1976d2;\r\n  font-size: 1.2rem;\r\n  font-weight: 600;\r\n  margin: 0 0 1rem 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.feature-preview h3::before {\r\n  content: \"✨\";\r\n  font-size: 1rem;\r\n}\r\n\r\n.feature-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 0.75rem;\r\n}\r\n\r\n.feature-list li {\r\n  background: linear-gradient(135deg, #e3f2fd, #bbdefb);\r\n  color: #1565c0;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 10px;\r\n  font-weight: 500;\r\n  font-size: 0.9rem;\r\n  transition: all 0.2s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.feature-list li::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\r\n  transition: left 0.5s ease;\r\n}\r\n\r\n.feature-list li:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.feature-list li:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.2);\r\n}\r\n\r\n.retirement-actions {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.retirement-actions .btn {\r\n  padding: 0.75rem 2rem;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  border-radius: 25px;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.retirement-actions .btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.retirement-footer {\r\n  border-top: 1px solid #e9ecef;\r\n  padding-top: 1.5rem;\r\n}\r\n\r\n.retirement-footer p {\r\n  color: #6c757d;\r\n  font-size: 0.9rem;\r\n  margin: 0;\r\n  font-style: italic;\r\n}\r\n\r\n/* 기업 선택 없을 때 스타일 */\r\n.no-selection {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\r\n}\r\n\r\n.no-selection-content {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  max-width: 500px;\r\n}\r\n\r\n.no-selection-icon {\r\n  font-size: 4rem;\r\n  margin-bottom: 1.5rem;\r\n  opacity: 0.7;\r\n}\r\n\r\n.no-selection h3 {\r\n  color: #495057;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.no-selection p {\r\n  color: #6c757d;\r\n  font-size: 1rem;\r\n  margin: 0 0 2rem 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.no-selection-features {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.feature-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 1rem;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.feature-item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.feature-icon {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.feature-item span:last-child {\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: #495057;\r\n}\r\n\r\n/* 에러 컨테이너 */\r\n.error-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.retry-btn {\r\n  margin-top: 1rem;\r\n  padding: 0.75rem 1.5rem;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.retry-btn:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n\r\n/* 직원 선택 콘텐츠 */\r\n.employee-selection-content {\r\n  text-align: center;\r\n  padding: 2rem;\r\n  animation: fadeInUp 0.6s ease-out;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 1024px) {\r\n  .retirement-settlement .company-sidebar {\r\n    width: 320px;\r\n    min-width: 320px;\r\n  }\r\n  .retirement-settlement .company-sidebar.folded {\r\n    width: 48px;\r\n    min-width: 48px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .retirement-layout {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .retirement-settlement .company-sidebar {\r\n    width: 100%;\r\n    height: 300px;\r\n    border-right: none;\r\n    border-bottom: 1px solid #e1e5e9;\r\n  }\r\n  \r\n  .retirement-content {\r\n    min-height: calc(100vh - 380px);\r\n  }\r\n  \r\n  .no-selection-content {\r\n    padding: 2rem 1rem;\r\n  }\r\n  \r\n  .no-selection-features {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .feature-item {\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    padding: 0.75rem 1rem;\r\n  }\r\n  \r\n  .retirement-header h1 {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .construction-icon {\r\n    font-size: 3rem;\r\n  }\r\n  \r\n  .message-box {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .feature-preview {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .feature-list {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  \r\n  .retirement-actions .btn {\r\n    padding: 0.6rem 1.5rem;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .employee-selection-content {\r\n    padding: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .retirement-settlement .company-sidebar {\r\n    height: 250px;\r\n  }\r\n  \r\n  .retirement-content {\r\n    min-height: calc(100vh - 330px);\r\n  }\r\n  \r\n  .no-selection-icon {\r\n    font-size: 3rem;\r\n  }\r\n  \r\n  .no-selection h3 {\r\n    font-size: 1.25rem;\r\n  }\r\n  \r\n  .no-selection p {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .retirement-header h1 {\r\n    font-size: 1.75rem;\r\n  }\r\n  \r\n  .construction-icon {\r\n    font-size: 2.5rem;\r\n  }\r\n  \r\n  .message-box {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .feature-list li {\r\n    padding: 0.6rem 0.8rem;\r\n    font-size: 0.85rem;\r\n  }\r\n  \r\n  .employee-selection-content {\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n/* 퇴직정산 담기 슬라이드 창 */\r\n.retirement-cart-slide {\r\n  position: fixed;\r\n  top: 80px;\r\n  right: 0;\r\n  width: 1200px;\r\n  height: calc(100vh - 80px);\r\n  background: white;\r\n  border-left: 1px solid #e1e5e9;\r\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);\r\n  z-index: 1000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transform: translateX(0);\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.cart-header {\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  background: #f8f9fa;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.cart-title-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.cart-header h3 {\r\n  margin: 0;\r\n  color: #495057;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.cart-close-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.5rem 1rem;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.cart-close-btn:hover {\r\n  background: #c82333;\r\n  box-shadow: 0 2px 6px rgba(220, 53, 69, 0.3);\r\n}\r\n\r\n.cart-controls {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.cart-download-btn {\r\n  background: #28a745;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 0.4rem 0.8rem;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.cart-download-btn:hover:not(:disabled) {\r\n  background: #218838;\r\n  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.cart-download-btn:disabled {\r\n  background: #6c757d;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n.cart-clear-btn {\r\n  background: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 0.4rem 0.6rem;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.cart-clear-btn:hover {\r\n  background: #5a6268;\r\n}\r\n\r\n.cart-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 0.75rem;\r\n}\r\n\r\n.cart-empty {\r\n  text-align: center;\r\n  padding: 1.5rem;\r\n  color: #6c757d;\r\n}\r\n\r\n.cart-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.cart-item {\r\n  background: #f8f9fa;\r\n  border: 1px solid #e1e5e9;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.cart-item:hover {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.cart-item-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.cart-item-header h4 {\r\n  margin: 0;\r\n  color: #495057;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.remove-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 24px;\r\n  height: 24px;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.remove-btn:hover {\r\n  background: #c82333;\r\n}\r\n\r\n.cart-item-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.detail-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.detail-row .label {\r\n  color: #6c757d;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.detail-row .value {\r\n  color: #212529;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.detail-row.total {\r\n  border-top: 1px solid #dee2e6;\r\n  padding-top: 0.5rem;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.detail-row.total .label {\r\n  color: #495057;\r\n  font-weight: 600;\r\n}\r\n\r\n.detail-row.total .value {\r\n  color: #28a745;\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* 담기 버튼 스타일 */\r\n.cart-actions {\r\n  padding: 1rem;\r\n  border-top: 1px solid #e1e5e9;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.add-to-cart-btn {\r\n  width: 100%;\r\n  background: #28a745;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.75rem 1rem;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.add-to-cart-btn:hover:not(:disabled) {\r\n  background: #218838;\r\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.add-to-cart-btn:disabled {\r\n  background: #6c757d;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n/* 카트 아이템 목록 스타일 - 간소화 */\r\n.cart-item-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.cart-item-summary {\r\n  background: #f8f9fa;\r\n  border: 1px solid #e1e5e9;\r\n  border-radius: 4px;\r\n  padding: 0.4rem 0.6rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.cart-item-summary:hover {\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.cart-item-simple {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.employee-name {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.employee-residentNumber {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.employee-joinDate {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.employee-amount {\r\n  font-weight: 700;\r\n  color: #28a745;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n/* 접혀있을 때 펼치기 버튼 */\r\n.cart-expand-button {\r\n  position: fixed;\r\n  top: 50%;\r\n  right: 20px;\r\n  transform: translateY(-50%);\r\n  z-index: 1001;\r\n}\r\n\r\n.cart-expand-btn {\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 1rem 1.5rem;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);\r\n  writing-mode: vertical-rl;\r\n  text-orientation: mixed;\r\n}\r\n\r\n.cart-expand-btn:hover {\r\n  background: #0056b3;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);\r\n}\r\n\r\n/* 카트 테이블 스타일 */\r\n.cart-table-container {\r\n  margin-top: 0.75rem;\r\n  border-top: 2px solid #007bff;\r\n  padding-top: 0.75rem;\r\n}\r\n\r\n.table-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.year-section {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.year-section:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.year-title {\r\n  margin: 0 0 0.6rem 0;\r\n  color: #495057;\r\n  font-size: 0.95rem;\r\n  font-weight: 700;\r\n  padding: 0.6rem 0.8rem;\r\n  background: linear-gradient(135deg, #007bff, #0056b3);\r\n  color: white;\r\n  border-radius: 4px;\r\n  text-align: center;\r\n  box-shadow: 0 1px 3px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.matrix-table-wrapper {\r\n  overflow-x: auto;\r\n  border-radius: 6px;\r\n  border: 1px solid #e1e5e9;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.matrix-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: white;\r\n  font-size: 0.8rem;\r\n  min-width: 400px;\r\n}\r\n\r\n.matrix-table thead {\r\n  background: linear-gradient(135deg, #f8f9fa, #e9ecef);\r\n}\r\n\r\n.matrix-table th {\r\n  padding: 0.6rem 0.4rem;\r\n  text-align: center;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  border-bottom: 2px solid #dee2e6;\r\n  font-size: 0.75rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.matrix-table td {\r\n  padding: 0.5rem 0.4rem;\r\n  text-align: center;\r\n  border-bottom: 1px solid #f1f3f4;\r\n  font-size: 0.75rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n.matrix-table tbody tr:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.year-month-header {\r\n  background: #007bff !important;\r\n  color: white !important;\r\n  font-weight: 700 !important;\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.year-month-cell {\r\n  font-weight: 600;\r\n  color: #495057;\r\n  background: #f8f9fa;\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 5;\r\n  border-right: 2px solid #dee2e6;\r\n}\r\n\r\n.employee-header {\r\n  background: #28a745 !important;\r\n  color: white !important;\r\n  font-weight: 700 !important;\r\n  min-width: 120px;\r\n  padding: 0.5rem 0.3rem !important;\r\n}\r\n\r\n/* 카트 매트릭스 테이블 헤더(초록 배경) 전용 — 스코프 없이 두면\r\n   직원 검색 목록/데이터 헤더의 같은 클래스에 흰색·민트색이 새어 나감 */\r\n.matrix-table .employee-header .employee-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.2rem;\r\n}\r\n\r\n.matrix-table .employee-header .employee-name {\r\n  font-size: 0.8rem;\r\n  font-weight: 700;\r\n  color: white;\r\n}\r\n\r\n.matrix-table .employee-header .employee-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.1rem;\r\n}\r\n\r\n.matrix-table .employee-header .employee-id {\r\n  font-size: 0.65rem;\r\n  color: #e8f5e8;\r\n  font-weight: 500;\r\n}\r\n\r\n.matrix-table .employee-header .employee-date {\r\n  font-size: 0.65rem;\r\n  color: #e8f5e8;\r\n  font-weight: 500;\r\n}\r\n\r\n.amount-cell {\r\n  font-weight: 500;\r\n  color: #495057;\r\n  min-width: 80px;\r\n}\r\n\r\n/* 합계 행 스타일 */\r\n.total-row {\r\n  background: #e3f2fd !important;\r\n  border-top: 2px solid #2196f3 !important;\r\n}\r\n\r\n.total-row:hover {\r\n  background: #bbdefb !important;\r\n}\r\n\r\n.total-label {\r\n  font-weight: 700 !important;\r\n  color: #1976d2 !important;\r\n  background: #e3f2fd !important;\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 5;\r\n  border-right: 2px solid #2196f3 !important;\r\n}\r\n\r\n.total-amount-cell {\r\n  font-weight: 700 !important;\r\n  color: #1976d2 !important;\r\n  background: #e3f2fd !important;\r\n}\r\n\r\n/* 퇴직정산 행 스타일 */\r\n.retirement-row {\r\n  background: #f3e5f5 !important;\r\n  border-top: 2px solid #9c27b0 !important;\r\n}\r\n\r\n.retirement-row:hover {\r\n  background: #e1bee7 !important;\r\n}\r\n\r\n.retirement-label {\r\n  font-weight: 700 !important;\r\n  color: #7b1fa2 !important;\r\n  background: #f3e5f5 !important;\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 5;\r\n  border-right: 2px solid #9c27b0 !important;\r\n}\r\n\r\n.retirement-amount-cell {\r\n  font-weight: 700 !important;\r\n  color: #7b1fa2 !important;\r\n  background: #f3e5f5 !important;\r\n}\r\n\r\n/* 총합계 행 스타일 */\r\n.grand-total-row {\r\n  background: #fff3e0 !important;\r\n  border-top: 3px solid #ff9800 !important;\r\n}\r\n\r\n.grand-total-row:hover {\r\n  background: #ffe0b2 !important;\r\n}\r\n\r\n.grand-total-label {\r\n  font-weight: 800 !important;\r\n  color: #f57c00 !important;\r\n  background: #fff3e0 !important;\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 5;\r\n  border-right: 2px solid #ff9800 !important;\r\n  font-size: 0.85rem !important;\r\n}\r\n\r\n.grand-total-amount {\r\n  font-weight: 800 !important;\r\n  color: #f57c00 !important;\r\n  background: #fff3e0 !important;\r\n  font-size: 0.85rem !important;\r\n  text-align: center !important;\r\n}\r\n\r\n/* 퇴직정산 선택 패널 스타일 */\r\n.retirement-selection {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100%;\r\n  padding: 2rem;\r\n}\r\n\r\n.retirement-options {\r\n  margin: 2rem 0;\r\n  width: 100%;\r\n  max-width: 800px;\r\n}\r\n\r\n.option-cards {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.option-card {\r\n  background: white;\r\n  border: 2px solid #e1e5e9;\r\n  border-radius: 12px;\r\n  padding: 2rem;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  flex: 1;\r\n  max-width: 400px;\r\n}\r\n\r\n.option-card:hover {\r\n  border-color: #007bff;\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 24px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.option-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.option-card h3 {\r\n  color: #495057;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  margin: 0 0 0.5rem 0;\r\n}\r\n\r\n.option-card p {\r\n  color: #6c757d;\r\n  font-size: 1rem;\r\n  margin: 0 0 1.5rem 0;\r\n}\r\n\r\n.option-features ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.option-features li {\r\n  color: #495057;\r\n  font-size: 0.9rem;\r\n  padding: 0.3rem 0;\r\n  position: relative;\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.option-features li::before {\r\n  content: '✓';\r\n  position: absolute;\r\n  left: 0;\r\n  color: #28a745;\r\n  font-weight: bold;\r\n}\r\n\r\n/* 패널 스타일 */\r\n.retirement-panel {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.panel-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n  padding: 1rem 2rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.back-to-selection-btn {\r\n  background: #6c757d;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.5rem 1rem;\r\n  font-size: 0.9rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  /* Login.css의 전역 button { width: 100% } 누수 방지 — 내용 크기만큼만 */\r\n  width: auto;\r\n  flex: 0 0 auto;\r\n  white-space: nowrap;\r\n}\r\n\r\n.back-to-selection-btn:hover {\r\n  background: #5a6268;\r\n}\r\n\r\n.panel-header h2 {\r\n  margin: 0;\r\n  color: #495057;\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.panel-content {\r\n  flex: 1;\r\n  padding: 2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.panel-message {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.panel-message h3 {\r\n  color: #495057;\r\n  font-size: 1.5rem;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.panel-message p {\r\n  color: #6c757d;\r\n  font-size: 1rem;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.selection-guide {\r\n  background: #f8f9fa;\r\n  border: 1px solid #e9ecef;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.selection-guide p {\r\n  color: #495057;\r\n  font-size: 0.9rem;\r\n  margin: 0;\r\n  font-style: italic;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 1400px) {\r\n  .retirement-cart-slide {\r\n    width: 1000px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .retirement-cart-slide {\r\n    width: 800px;\r\n  }\r\n  \r\n  .matrix-table {\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .matrix-table th,\r\n  .matrix-table td {\r\n    padding: 0.4rem 0.3rem;\r\n  }\r\n  \r\n  .employee-header {\r\n    min-width: 100px;\r\n  }\r\n  \r\n  .amount-cell {\r\n    min-width: 70px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .retirement-cart-slide {\r\n    width: 100%;\r\n    height: calc(100vh - 80px);\r\n  }\r\n  \r\n  .cart-header {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .cart-content {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .cart-item-summary {\r\n    padding: 0.4rem;\r\n  }\r\n  \r\n  .matrix-table {\r\n    font-size: 0.7rem;\r\n  }\r\n  \r\n  .matrix-table th,\r\n  .matrix-table td {\r\n    padding: 0.3rem 0.2rem;\r\n  }\r\n  \r\n  .year-title {\r\n    font-size: 0.85rem;\r\n    padding: 0.4rem 0.6rem;\r\n  }\r\n  \r\n  .employee-header {\r\n    min-width: 80px;\r\n  }\r\n  \r\n  .amount-cell {\r\n    min-width: 60px;\r\n  }\r\n  \r\n  .matrix-table .employee-header .employee-name {\r\n    font-size: 0.7rem;\r\n  }\r\n\r\n  .matrix-table .employee-header .employee-id,\r\n  .matrix-table .employee-header .employee-date {\r\n    font-size: 0.6rem;\r\n  }\r\n  \r\n  /* 선택 패널 반응형 */\r\n  .retirement-selection {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .option-cards {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .option-card {\r\n    padding: 1.5rem;\r\n  }\r\n  \r\n  .option-icon {\r\n    font-size: 2.5rem;\r\n  }\r\n  \r\n  .option-card h3 {\r\n    font-size: 1.3rem;\r\n  }\r\n  \r\n  .panel-header {\r\n    padding: 0.75rem 1rem;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .panel-header h2 {\r\n    font-size: 1.3rem;\r\n  }\r\n  \r\n  .panel-content {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .panel-message {\r\n    padding: 2rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .cart-header h3 {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .cart-item-header h4 {\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .detail-row .label,\r\n  .detail-row .value {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n/* ── 연도별 부담금 (카트) ── */\r\n.cart-item-yearly {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  padding: 4px 8px 8px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.cart-yearly-chip {\r\n  background: #ede7f6;\r\n  color: #4527a0;\r\n  border-radius: 8px;\r\n  padding: 1px 8px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.cart-leave-warning {\r\n  color: #e65100;\r\n  font-weight: 700;\r\n  margin-left: 4px;\r\n}\r\n\r\n.matrix-table .year-contrib-row td {\r\n  background: #ede7f6;\r\n  font-weight: 600;\r\n  color: #4527a0;\r\n}\r\n\r\n.matrix-table .year-contrib-row .retirement-label {\r\n  white-space: nowrap;\r\n}\r\n\r\n/* 직원을 바꿔 자료를 다시 받는 동안: 화면 전체 대신 표 위에만 반투명 막을 씌운다 */\r\n.retirement-data-content { position: relative; }\r\n.retirement-data-display.is-loading .retirement-data-content > :not(.retirement-loading-veil) { opacity: 0.45; transition: opacity 0.15s; }\r\n.retirement-loading-veil { position: absolute; top: 12px; left: 50%; z-index: 5; transform: translateX(-50%); padding: 4px 12px; border-radius: 12px; background: #1864ab; color: #fff; font-size: 12.5px; font-weight: 600; }\r\n.retirement-inline-loading { padding: 24px; color: #6c757d; text-align: center; }\r\n.retirement-inline-error { margin: 8px 0; padding: 8px 12px; border-radius: 4px; background: #fdf0f1; color: #b02a37; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
